import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {RmeNodeDaoAbstractService} from '../../../core/abstract/rme-node-dao-abstract.service';

import {GridStrategy} from './models/interfaces';

@Injectable({
  providedIn: 'root'
})
export class ReferenceGridStrategyService implements GridStrategy {
  constructor(private readonly nodeService: RmeNodeDaoAbstractService) {}

  public getItems({rmId, options, query}): Observable<any> {
    return this.nodeService.getNodesByParent(rmId, options.data.id, query);
  }

  public getParentId(parentId: string, refModelId: string): string | null {
    return parentId || refModelId;
  }
}
